import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getPlatforms, IonButton, IonCard, IonCol, IonContent, IonGrid, IonIcon, IonPage, IonRow, IonText } from '@ionic/react';
import { addCircle, peopleCircle } from 'ionicons/icons';

import { SessionDefaultStateI } from '../../store/session/SessionReducer';
import { ABMUsersDefaultStateI } from '../../store/ABMUsers/ABMUsersReducer';
import { GetABMUsers } from '../../store/ABMUsers/ABMUsersActions';
import { GetClientMaintenance } from '../../store/mainInfo/mainInfoActions';
import { ABMConsultaDefaultStateI } from '../../store/ABMUsers/ABMConsulta/ABMConsultaReducer';
import { GetABMConsulta } from '../../store/ABMUsers/ABMConsulta/ABMConsultaActions';

import Header from '../header/Header';
import Loading from '../Loading/Loading';
import ListClientsModal from './ListClientsModal';
import Footer from '../Footer/Footer';
import AddABMUsersConsulta from './AddABMUsersConsulta';
import ABMConsultaTable from './ABMConsultaTable';
import ABMUsers from './ABMUsers';
import ABMUsersMainPage from './ABMUsersMainPage';
import ModifyABMConsulta from './ModifyABMConsulta';

import './ABMUsers.css';

interface Data {
    client_access_name: string,
    client_access_permissions: string[]
}

interface Props extends StateTypes, dispatchTypes { }

const ABMConsulta: React.FC<Props> = (props): JSX.Element => {

    const [clientUsers, setClientUsers] = useState<string | null>(sessionStorage.getItem('clientUsers'));
    const [showModal, setShowModal] = useState(false);
    const [clientSelected, setClientSelected] = useState('');
    const [consultas, setConsultas] = useState<any>([]);
    const [renderViews, setRenderViews] = useState<any>({
        showTable: true,
        showCreate: false,
        showModify: false,
        showUser:false,
        showMainPage:false,
    });

    const [dataToModify, setDataToModify] = useState<Data>({
        client_access_name: '',
        client_access_permissions: [],
    })

    const [dataUser, setDataUser] =useState<Data>({
        client_access_name: '',
        client_access_permissions:['']
    })
    const [shouldRefresh, setShouldRefresh] = useState(false);
    const desktop = getPlatforms().includes("desktop")

    useEffect(() => {

        function handleResize() {
            setShouldRefresh(true);
        }

        if (desktop) {
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }

    }, []);

    useEffect(() => {
        if (props.ABMConsulta.loading === false && props.ABMConsulta.abmconsulta) {  
            setConsultas(props.ABMConsulta.abmconsulta); 
        }
    }, [props.ABMConsulta.abmconsulta]);
    

    useEffect(() => {
            const storedClientUsers = sessionStorage.getItem('clientUsers');
            if (storedClientUsers !== clientUsers) {
                setClientUsers(storedClientUsers);
                backToConsulta()
            }
        }, [sessionStorage.getItem('clientUsers')]);

    useEffect(() => {
        if (shouldRefresh) {
            setShouldRefresh(false);
            window.location.reload();
        }
    }, [shouldRefresh]);

    useEffect(() => {
        if (props.session.loading === false && props.session.loginData) {
            props.getClientsAdmin()
            props.getABMConsulta()
            if (!sessionStorage.getItem("clientUsers")) {
                sessionStorage.setItem("clientUsers", '')
            }
            if (sessionStorage.getItem("clientUsers") === '') {
                setShowModal(true)
            }
        }
    }, []);

    useEffect(() => {
        if (sessionStorage.getItem('clientUsers') !== '') {
            setShowModal(false);
        }
    }, [sessionStorage.getItem("clientUsers")])

    useEffect(() => {
        if (props.ABMConsulta.loading === false && props.ABMConsulta.abmconsulta) {  
            setConsultas(props.ABMConsulta.abmconsulta);
        }
    }, [sessionStorage.getItem('clientUsers'), props.ABMUsers.loading, props.ABMUsers.abmusers])

    const selectClient = (clientName: string) => {
        sessionStorage.setItem("clientUsers", clientName)
        setClientSelected(clientName)
    }

    const showModalFunc = () => {
        setShowModal(true);
    }

    const closeModalFunc = () => {
        setShowModal(false);
    }

    const renderCreate = () => {
        setRenderViews({
            showTable: false,
            showCreate: true,
            showModify: false,
            showUser:false,
            showMainPage:false
        })
    }

    const renderModify = (data: Data) => {
        setRenderViews({
            showTable: false,
            showCreate: false,
            showModify: true,
            showUser:false,
            showMainPage:false
        })
        setDataToModify(data)
    }

    const renderUser = (data:Data) => {
        setDataUser(data)
        setRenderViews({
            showTable: false,
            showCreate: false,
            showModify: false,
            showUser:true,
            showMainPage:false
        })
    }

    const backToTable = () => {
        setRenderViews({
            showTable: true,
            showCreate: false,
            showModify: false,
            showUser:false,
            showMainPage:false
        })
    }

    const backToConsulta = ()=>{
        setRenderViews({
            showTable: false,
            showCreate: false,
            showModify: false,
            showUser:false,
            showMainPage:true
        })
    }

    return (
        <IonPage>
            <Header headerText='ABM Usuarios' />
            {
                renderViews.showMainPage? <ABMUsersMainPage/> :
                renderViews.showCreate ? <AddABMUsersConsulta backToTable={backToTable} client={sessionStorage.getItem('clientUsers')} /> :
                 renderViews.showUser ? <ABMUsers client={dataUser}/> :
                    renderViews.showModify ? <ModifyABMConsulta userConsulta={dataToModify} backToTable={backToTable} /> :
                        renderViews.showTable && sessionStorage.getItem('clientUsers') !== ''?
                            <div className="custom-content-scroll">
                                <IonGrid id='ion-content-main' >
                                    <IonCard className="ion-padding ABMUsersTable">
                                        <IonRow className="ion-align-items-center ion-justify-content-between">
                                            <IonCol sizeXl='6' sizeLg='4'>
                                                <IonRow className="ion-align-items-center">
                                                    <IonButton title="Seleccionar cliente" fill="clear" type="button" className="client-icon" onClick={() => showModalFunc()}>
                                                        <IonIcon icon={peopleCircle} className="header-icon-select-client" />
                                                    </IonButton>
                                                    <IonText>
                                                        <h5 className='ABMUsersContainerTitle ion-no-margin'>
                                                            {sessionStorage.getItem("clientUsers")}
                                                        </h5>
                                                    </IonText>
                                                </IonRow>
                                            </IonCol>
                                            <IonCol sizeXl='1' sizeLg='1' sizeMd='1' sizeSm='1.5' sizeXs='2' className="container-add-user">
                                                <IonButton fill='clear' className="client-icon" onClick={renderCreate}>
                                                    <IonIcon icon={addCircle} color="secondary" className="ABMUsersHeaderIconAddUser" />
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                        <IonCard className="ABMUsersCardTable">
                                            <IonGrid className="ABMUsersGrid">
                                                <IonRow>
                                                    <IonCol className="ABMUsersCol ABMUsersColTitle" sizeLg="2" sizeXs='9'>
                                                        <IonText>Tipo de consulta</IonText>
                                                    </IonCol>
                                                    <IonCol className="ABMUsersCol ABMUsersColTitle ABMUsersTableMobile-hidden ABMUsersReducedTableMobile-hidden" sizeLg="7">
                                                        <IonText>Clientes que visualiza</IonText>
                                                    </IonCol>
                                                    <IonCol className="ABMUsersCol ABMUsersColTitle ABMUsersTableMobile-hidden ABMUsersReducedTableMobile-hidden" sizeLg="1">
                                                        <IonText>Modificar</IonText>
                                                    </IonCol>
                                                    <IonCol className="ABMUsersCol ABMUsersColTitle" sizeLg="1" sizeXs='3'>
                                                        <IonText>Ver</IonText>
                                                    </IonCol>
                                                    <IonCol className="ABMUsersCol ABMUsersColTitle ABMUsersTableMobile-hidden ABMUsersReducedTableMobile-hidden hidden-col" sizeLg="1">
                                                        <IonText>Eliminar</IonText>
                                                    </IonCol>
                                                </IonRow>
                                                {
                                                    consultas.map((consulta: any) => {
                                                        return (
                                                            <ABMConsultaTable
                                                                key={consulta.client_access_name}
                                                                consultaData={consulta}
                                                                userCallback={renderUser} 
                                                                modifyCallback={renderModify}
                                                                />
                                                        )
                                                    })
                                                }
                                            </IonGrid>
                                        </IonCard>
                                    </IonCard>
                                </IonGrid>
                            </div>
                            : <Loading />
            }
            <ListClientsModal
                parentCallback={selectClient}
                showModal={showModal}
                closeModalCallback={closeModalFunc} />
            <Footer />
        </IonPage>
    );
}

interface StateTypes {
    session: SessionDefaultStateI;
    ABMUsers: ABMUsersDefaultStateI,
    ABMConsulta: ABMConsultaDefaultStateI,
}

const mapStateProps = (state: StateTypes) => {
    return {
        ABMUsers: state.ABMUsers,
        session: state.session,
        ABMConsulta:state.ABMConsulta,
    }
}

interface dispatchTypes {
    getABMUsers: () => void;
    getClientsAdmin: () => void;
    getABMConsulta:() => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getABMUsers: () => dispatch(GetABMUsers()),
        getClientsAdmin: () => dispatch(GetClientMaintenance()),
        getABMConsulta: () => dispatch(GetABMConsulta()),
    };
}

export default connect(mapStateProps, mapDispatchToProps)(ABMConsulta);